module.exports = __webpack_public_path__ + "static/guarantee-f8c9d5e2bde8918edcfd9dd379a4c2f2.svg";